import OpenAI from 'openai';

const openai = new OpenAI({
  apiKey: import.meta.env.VITE_OPENAI_API_KEY,
  dangerouslyAllowBrowser: true
});

export interface SentimentAnalysis {
  sentiment: 'positive' | 'negative' | 'neutral';
  confidence: number;
  mood: string;
}

export const SentimentService = {
  async analyze(text: string): Promise<SentimentAnalysis> {
    try {
      const response = await openai.chat.completions.create({
        model: "gpt-3.5-turbo",
        messages: [
          {
            role: "system",
            content: "Analise o sentimento do texto e responda APENAS com: positive, negative ou neutral"
          },
          { role: "user", content: text }
        ]
      });

      const sentiment = response.choices[0]?.message?.content?.toLowerCase().trim() || 'neutral';
      
      return {
        sentiment: sentiment as 'positive' | 'negative' | 'neutral',
        confidence: 0.9,
        mood: sentiment === 'positive' ? 'alegre' : 
              sentiment === 'negative' ? 'preocupado' : 'neutro'
      };
    } catch (error) {
      console.error('Erro ao analisar sentimento:', error);
      return {
        sentiment: 'neutral',
        confidence: 0.5,
        mood: 'neutro'
      };
    }
  }
};
